import { render } from "./MetalPlayer.vue?vue&type=template&id=986b3b8e&scoped=true"
import script from "./MetalPlayer.vue?vue&type=script&lang=js"
export * from "./MetalPlayer.vue?vue&type=script&lang=js"

import "./MetalPlayer.vue?vue&type=style&index=0&id=986b3b8e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986b3b8e"]])

export default __exports__